import React, { useRef } from 'react';
import cn from 'classnames';

import { useTranslation, useAppSelector, useAppDispatch } from 'client/hooks';
import { getAllUsersMetadata, getRaiseHandMessagesCount, getReactionsMessagesCount } from 'client/redux/pubnub/actions';
import { thousandSeparator } from 'utils/thousand-separator';
import { selectRoomId } from 'client/redux/room/selectors';

import GeneralStatisticsList from '../../../GeneralStatisticsList';
import { DrawersTransitionWrap } from '../../DrawersTransitionWrap';

import css from './UsersStatisticMenu.module.scss';

interface Props {
  visible: boolean;
  className?: string;
  totalListenersCount?: number;
  connectedListenersCount?: number;
  pendingRequestsCount?: number;
}

const StatisticMenu: React.FC<Props> = (props) => {
  const { className, connectedListenersCount = 0, pendingRequestsCount = 0, totalListenersCount = 0, visible } = props;
  const isMountedRef = useRef(false);
  const roomId = useAppSelector(selectRoomId);
  const dispatch = useAppDispatch();
  const { translate } = useTranslation('actionsPanel');

  React.useEffect(() => {
    if (visible && !isMountedRef.current) {
      isMountedRef.current = true;
      dispatch(getRaiseHandMessagesCount({ roomId }));
      dispatch(getReactionsMessagesCount({ roomId }));
      dispatch(getAllUsersMetadata({ roomId }));
    }
    // need this only when drawers prop {visible} is true
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);

  return (
    <DrawersTransitionWrap visible={visible}>
      <div className={cn(css.statisticMenu, className)} data-testid="user-statistic-menu">
        <div className={css.title}>
          <div className={css.line}></div>
          {translate('usersStatisticsDrawer.title')}{' '}
          <span className={css.counter}>({thousandSeparator(totalListenersCount)})</span>
        </div>
        <GeneralStatisticsList
          totalListenersCount={totalListenersCount}
          connectedListenersCount={connectedListenersCount}
          pendingRequestsCount={pendingRequestsCount}
        />
      </div>
    </DrawersTransitionWrap>
  );
};

export default StatisticMenu;
